/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'entertainment-outside-venue',
    templateUrl: './entertainment-outside-venue.component.html',
    styleUrls: ['./entertainment-outside-venue.component.scss']
})
export class EntertainmentOutsideVenueComponent implements OnInit {

    public vendorPrefixId = '';
    public dialogRef: any;

    constructor(public router: Router, public route: ActivatedRoute) {
    }
    
    ngOnInit() {
        this.route.params.subscribe((params) => {
            if(params && params.vendorPrefixId){
                this.vendorPrefixId = params.vendorPrefixId;
            }
        })
    }

    
  

    // calls listSandbox getPageDetail for detail page

}
